/* @refresh reload */
import { render } from "solid-js/web";
import { lazy } from "solid-js";
import { Route, Router } from "@solidjs/router";
import App from "./App";
import { LocaleProvider } from "./i18n/LocaleProvider";
import "./styles.css";

const CanvasRoute = lazy(() => import("./routes/CanvasRoute"));
const SignupRoute = lazy(() => import("./routes/SignupRoute"));
const SigninRoute = lazy(() => import("./routes/SigninRoute"));
const MeRoute = lazy(() => import("./routes/MeRoute"));
const ProfileRoute = lazy(() => import("./routes/ProfileRoute"));
const PieceRoute = lazy(() => import("./routes/PieceRoute"));
const CreateRoute = lazy(() => import("./routes/CreateRoute"));
const QuickCreateRoute = lazy(() => import("./routes/QuickCreateRoute"));
const CuratorInbox = lazy(() => import("./routes/CuratorInbox"));
const CuratorCanvas = lazy(() => import("./routes/CuratorCanvas"));
const CuratorAudit = lazy(() => import("./routes/CuratorAudit"));

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

// Curator routes mount under @solidjs/router so the nested admin-gated
// pages share state cleanly. The rest of the app keeps the lightweight
// path-match dispatcher until WEB1 ships the session-aware shell.
const path = window.location.pathname.replace(/\/+$/, "");

if (path.startsWith("/curator")) {
  render(
    () => (
      <LocaleProvider>
        <Router>
          <Route path="/curator" component={CuratorInbox} />
          <Route path="/curator/inbox" component={CuratorInbox} />
          <Route path="/curator/canvas" component={CuratorCanvas} />
          <Route path="/curator/audit" component={CuratorAudit} />
        </Router>
      </LocaleProvider>
    ),
    root,
  );
} else {
  const PageRoute =
    path === "/canvas"
      ? CanvasRoute
      : path === "/signup"
        ? SignupRoute
        : path === "/signin"
          ? SigninRoute
          : path === "/me"
            ? MeRoute
            : path === "/me/profile"
              ? ProfileRoute
            : path.startsWith("/p/")
              ? PieceRoute
              : path === "/create/quick"
                ? QuickCreateRoute
                : path === "/create"
                  ? CreateRoute
                  : App;
  render(
    () => (
      <LocaleProvider>
        <PageRoute />
      </LocaleProvider>
    ),
    root,
  );
}
